/* eslint-disable no-redeclare */

import { dateToAge } from '@hc-frontend/core-utils-date';
import { z } from 'zod';

import { MemberBase } from './member-base';
import { MemberType } from './member-type';

export const Child = MemberBase.extend({
  memberType: z.literal(MemberType.Enum.CHILD),
}).superRefine((data, ctx) => {
  if (!data.dateOfBirth) {
    return z.NEVER;
  }

  const age = data.dateOfBirth ? dateToAge(data.dateOfBirth) : 0;

  if (age < 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Age must be 0 or more years old.',
    });
  }

  if (age >= 26) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Age must be under 26 years old.',
    });
  }

  return z.NEVER;
});

export type Child = z.infer<typeof Child>;
